/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAuthChangePasswordRequest,
    AdminAuthChangePasswordRequestFromJSON,
    AdminAuthChangePasswordRequestToJSON,
    AuthMeResponse,
    AuthMeResponseFromJSON,
    AuthMeResponseToJSON,
    AuthRequest,
    AuthRequestFromJSON,
    AuthRequestToJSON,
    AuthTokenResponse,
    AuthTokenResponseFromJSON,
    AuthTokenResponseToJSON,
} from '../models';

export interface AuthApiPostAdminChangePasswordRequest {
    params: AdminAuthChangePasswordRequest;
}

export interface AuthApiPostAdminLogInRequest {
    params: AuthRequest;
}

export function createGetMePath(): string {
    return `/me`;
}
export function createGetMeFullPath(): string {
    return runtime.BASE_PATH + `/me`;
}
export function createPostAdminChangePasswordPath(): string {
    return `/admin/change-password`;
}
export function createPostAdminChangePasswordFullPath(): string {
    return runtime.BASE_PATH + `/admin/change-password`;
}
export function createPostAdminLogInPath(): string {
    return `/admin/login`;
}
export function createPostAdminLogInFullPath(): string {
    return runtime.BASE_PATH + `/admin/login`;
}
export function createPostAdminRefreshAccessTokenPath(): string {
    return `/admin/refresh-access-token`;
}
export function createPostAdminRefreshAccessTokenFullPath(): string {
    return runtime.BASE_PATH + `/admin/refresh-access-token`;
}
export function createPostAdminRefreshRefreshTokenPath(): string {
    return `/admin/refresh-refresh-token`;
}
export function createPostAdminRefreshRefreshTokenFullPath(): string {
    return runtime.BASE_PATH + `/admin/refresh-refresh-token`;
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
    /**
     * Get user info
     * Get user info
     */
    async getMe(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ApiResponse<AuthMeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createGetMePath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AuthMeResponseFromJSON(jsonValue))
        );
    }
    /**
     * Change password
     * Change password
     */
    async postAdminChangePassword(
        requestParameters: AuthApiPostAdminChangePasswordRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminChangePassword.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminChangePasswordPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminAuthChangePasswordRequestToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Log in
     * Log in
     */
    async postAdminLogIn(
        requestParameters: AuthApiPostAdminLogInRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AuthTokenResponse>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminLogIn.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminLogInPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AuthRequestToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AuthTokenResponseFromJSON(jsonValue))
        );
    }
    /**
     * Refresh access token
     * Refresh access token
     */
    async postAdminRefreshAccessToken(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AuthTokenResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminRefreshAccessTokenPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AuthTokenResponseFromJSON(jsonValue))
        );
    }
    /**
     * Refresh the refresh token
     * Refresh the refresh token
     */
    async postAdminRefreshRefreshToken(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminRefreshRefreshTokenPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
}
